export default __webpack_public_path__ + "static/media/easy_storage_solutions_logo.58d499ea.png";